import { useState, useEffect, useRef } from 'react';

export default function BusinessProblems() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const problems = [
    {
      icon: 'ri-puzzle-line',
      title: 'Phần mềm mua sẵn không khớp quy trình',
      description: 'Giải pháp có sẵn không đáp ứng được đặc thù nghiệp vụ của doanh nghiệp'
    },
    {
      icon: 'ri-tools-line',
      title: 'Phải "uốn" nghiệp vụ theo hệ thống',
      description: 'Thay đổi cách làm việc để phù hợp với phần mềm thay vì ngược lại'
    },
    {
      icon: 'ri-link-unlink-m',
      title: 'Hệ thống chắp vá, khó tích hợp',
      description: 'Nhiều phần mềm rời rạc, khó kết nối và mở rộng'
    },
    {
      icon: 'ri-lock-line',
      title: 'Phụ thuộc nhà cung cấp',
      description: 'Khó làm chủ công nghệ và kiểm soát hệ thống'
    }
  ];

  return (
    <section ref={sectionRef} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className={`text-center mb-16 transition-all duration-1000 delay-200 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2a4b7c] mb-6">
            Nhiều doanh nghiệp gặp phải tình trạng
          </h2>
          <div className={`w-20 h-1 bg-[#06b6d4] mx-auto transition-all duration-1000 delay-400 ${
            isVisible ? 'opacity-100 scale-x-100' : 'opacity-0 scale-x-0'
          }`} style={{ transformOrigin: 'center' }}></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((problem, index) => (
            <div
              key={index}
              className={`group relative bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-200 hover:border-[#06b6d4] transition-all duration-500 hover:shadow-xl hover:-translate-y-2 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${400 + index * 100}ms` }}
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#06b6d4]/5 to-transparent rounded-bl-full"></div>
              
              <div className="relative">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#06b6d4] to-[#06b6d4] rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${problem.icon} text-3xl text-white`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-[#2a4b7c] mb-3 leading-tight">
                  {problem.title}
                </h3>
                
                <p className="text-gray-600 text-sm leading-relaxed">
                  {problem.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}